import { Badge, Button, Col, Collapse, Form, Row } from 'antd';
import { useIntl } from 'react-intl';
import { FloatingFormItem } from '@/components/_common';
import GroupsInfiniteSelectField from '@/components/_common/GroupsInfiniteSelectField';
import NcmSelectField from '@/components/_common/NcmSelectField';
import EmployeesSelectedModal from '@/components/_common/EmployeesSelectedModal';
import { useDisclosure } from '@/hooks';
import CustomersSelectedModal from '@/components/_common/CustomersSelectedModal';
import SpaceForButton from '@/components/_common/SpaceForButtons';

const MoreOptionsDailyMovementReport: React.FC = () => {
  const { Panel } = Collapse;
  const intl = useIntl();
  const form = Form.useFormInstance();

  const [selectEmplooyesModal, selectEmployeesModalActions] = useDisclosure();
  const [selectCustomersModal, selectCustomersModalActions] = useDisclosure();

  return (
    <>
      <Col sm={24}>
        <Collapse accordion>
          <Panel
            header={intl.formatMessage({
              id: 'movementDailyMovementReport.form.moreOptions',
            })}
            key={1}
          >
            <Row gutter={[36, 12]}>
              <Col xs={24} sm={12}>
                <FloatingFormItem
                  name="NCM"
                  label={intl.formatMessage({
                    id: 'movementDailyMovementReport.form.moreOptions.ncm',
                  })}
                >
                  <NcmSelectField />
                </FloatingFormItem>
              </Col>

              <Col xs={24} sm={12}>
                <FloatingFormItem
                  name="subGroupIds"
                  label={intl.formatMessage({
                    id: 'movementDailyMovementReport.form.moreOptions.groups',
                  })}
                >
                  <GroupsInfiniteSelectField mode="multiple" allowClear />
                </FloatingFormItem>
              </Col>

              <Col>
                <Form.Item noStyle name="estimatorIds" hidden />
                <Form.Item noStyle name="customerIds" hidden />

                <SpaceForButton>
                  <Badge count={form.getFieldValue('estimatorIds')?.length}>
                    <Button
                      onClick={selectEmployeesModalActions.open}
                      type="primary"
                      block
                    >
                      Selecionar Orçamentistas
                    </Button>
                  </Badge>

                  <Badge count={form.getFieldValue('customerIds')?.length}>
                    <Button
                      onClick={selectCustomersModalActions.open}
                      type="primary"
                      block
                    >
                      Selecionar Clientes
                    </Button>
                  </Badge>
                </SpaceForButton>
              </Col>
            </Row>
          </Panel>
        </Collapse>
      </Col>

      <EmployeesSelectedModal
        queryFilter={{ estimator: true }}
        handleVisible={selectEmployeesModalActions.close}
        visible={selectEmplooyesModal}
        finishCallback={(e) => form.setFieldValue('estimatorIds', e)}
        selectedEmployeesIds={form.getFieldValue('estimatorIds')}
      />

      <CustomersSelectedModal
        visible={selectCustomersModal}
        handleVisible={selectCustomersModalActions.close}
        selectedCustomerIds={form.getFieldValue('customerIds')}
        finishCallback={(customer) =>
          form.setFieldValue('customerIds', customer)
        }
      />
    </>
  );
};

export default MoreOptionsDailyMovementReport;
